// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"b7eff512","92":"fdf75abf","156":"79c88318","456":"ecaeb467","616":"512ff6cf","812":"6148fa8d","920":"eb28880f","964":"bf8c0416"}[chunkId] + ".chunk.js";
};